<template>
  <van-tabbar v-model="active" route :placeholder="false" :fixed="false">
    <van-tabbar-item
      v-for="item in !loginDiaInfo.isTokenTab
        ? loginDiaInfo.isAgentPerson === 1
          ? tabbarList
          : listData
        : tabbarListAgentLogin"
      :key="item.path"
      replace
      :name="item.path"
      :to="item.to"
    >
      <template #icon="props">
        <img :src="props.active ? item.activeImg : item.img" />
      </template>
      <span>{{ item.label }}</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script lang="ts" setup>
  import { storage } from '@/utils/storage';
  import homeIcon from './tabImg/home.png';
  import homeaIcon from './tabImg/homea.png';
  import mineIcon from './tabImg/mine.png';
  import mineaIcon from './tabImg/minea.png';
  import promotionIcon from './tabImg/promotion.png';
  import promotionaIcon from './tabImg/promotiona.png';
  import assetsIcon from './tabImg/assets.png';
  import assetsaIcon from './tabImg/assetsa.png';
  import vipIcon from './tabImg/vip.png';
  import vipaIcon from './tabImg/vipa.png';
  import { useLoginDialog } from '@/store';
  const route = useRoute();
  const router = useRouter();
  const show = defineModel<boolean>('show');
  const loginDiaInfo = useLoginDialog();
  const active = ref(route.path);
  const tabbarList = [
    {
      label: '首页',
      to: { name: 'Home' },
      path: '/index',
      img: homeIcon,
      activeImg: homeaIcon,
    },
    {
      label: '资产',
      to: { name: 'Property' },
      path: '/property',
      img: assetsIcon,
      activeImg: assetsaIcon,
    },
    // {
    //   label: '推广',
    //   to: { name: 'Promotion' },
    //   path: '/promotion',
    //   img: promotionIcon,
    //   activeImg: promotionaIcon,
    //   // isShow:true
    // },
    // {
    //   label: '会员',
    //   to: { name: 'VipLandingPage' },
    //   path: '/vipLandingPage',
    //   img: vipIcon,
    //   activeImg: vipaIcon,
    // },
    {
      label: '我的',
      to: { name: 'Mine' },
      path: '/mine',
      img: mineIcon,
      activeImg: mineaIcon,
    },
  ];

  const tabbarListAgent = [
    {
      label: '首页',
      to: { name: 'Home' },
      path: '/index',
      img: homeIcon,
      activeImg: homeaIcon,
    },
    {
      label: '我要推广',
      to: { name: 'GoPromote' },
      path: '/goPromote',
      img: promotionIcon,
      activeImg: promotionaIcon,
    },
    {
      label: '我的',
      to: { name: 'Mine' },
      path: '/mine',
      img: mineIcon,
      activeImg: mineaIcon,
    },
  ];

  const tabbarListAgentLogin = [
    {
      label: '首页',
      to: { name: 'Home' },
      path: '/index',
      img: homeIcon,
      activeImg: homeaIcon,
    },
    {
      label: '我的',
      to: { name: 'Mine' },
      path: '/mine',
      img: mineIcon,
      activeImg: mineaIcon,
    },
  ];

  // 是否登录
  const isLogin = loginDiaInfo.checkIsLogin({ showModal: false });
  const userInfo = computed(() => loginDiaInfo.loginInfo);

  // 计算属性判断导航栏端口开放 isAgentPerson 0--C端 1--L端
  const listData = computed(() => {
    console.log('=====================>isLogin', isLogin);
    // 默认进来是c端
    // 未登录 首页-我的
    if (!isLogin) {
      return tabbarListAgentLogin;
    }
    // 已登录-不是代理-查询过报告   仅有首页-我的
    if (isLogin && userInfo.value.isAgent == 0 && userInfo.value.isBuyPromote == 1) {
      return tabbarListAgentLogin;
    }
    // 已登录-不是代理-未查询过报告  首页-我要推广-我的
    if (isLogin && userInfo.value.isAgent == 0 && userInfo.value.isBuyPromote == 0) {
      return tabbarListAgent;
    }
    // 已登录-是代理  首页-我要推广-我的  我要推广跳L端首页
    if (isLogin && userInfo.value.isAgent == 1) {
      // 切换到L端
      // return tabbarListAgent;
      return tabbarListAgentLogin;
    }
    if (isLogin && route.name == 'GoPromote') {
      return tabbarListAgent;
    }
    return [];
  });

  watch(
    () => route.name,
    (newVal) => {
      console.log({ newVal });

      // show.value = tabbarList.findIndex((item) => item.to.name === newVal) >= 0;
      show.value =
        ['Home', 'Property', 'GoPromote', 'Mine', 'VipLandingPage'].findIndex(
          (item) => item === newVal
        ) >= 0;
    },
    { immediate: true }
  );
</script>

<style scoped></style>
